import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

export const reset = createAction<ActionType, Reset>(
    ActionType.COACHING_DETAIL__TD__RESET,
);
